import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import { Bold, Container, Description, Label, Title, Wrapper } from './CookiesConditions.elements';

export interface CookiesConditionsProps { }

const CookiesConditionsTemplate: FC<CookiesConditionsProps> = () => {
    return (
        <Wrapper>
            <Title>SÚHLAS S POUŽÍVANÍM COOKIES</Title>
            <Container>
                <Label>Pravidlá používania cookies</Label>
                <Description>
                    Týmto si Vás dovoľujeme informovať o používaní cookies, o účeloch ich použitia a možnostiach
                    nastavenie svojho internetového prehliadača v prípade, keď Vám aktuálne nastavenie využívania cookies
                    nevyhovuje.
                </Description>
            </Container>
            <Container>
                <Label>Čo sú cookies?</Label>
                <Description>
                    Cookies sú malé textové súbory, ktoré môžu byť pri návšteve webových stránok odoslané do Vášho
                    internetového prehliadača a uložené do Vášho zariadenia. Súbory cookies sa ukladajú do priečinka pre
                    súbory internetového prehliadača. Cookies zvyčajne obsahujú názov webovej stránky, z ktorej pochádzajú
                    a dátum svojho vzniku. Pri ďalšej návšteve danej webovej stránky internetový prehliadač opäť načíta
                    súbory cookies a tieto informácie odošle späť webovej stránke, ktorá cookies vytvorila.
                </Description>
            </Container>
            <Container>
                <Label>Aké cookies využívame?</Label>
                <Description>
                    Spoločnosť Poradca podnikateľa, spol. s r.o. používa na svojich webových stránkach nasledujúce typy súborov cookies:
                </Description>
                <Description>
                    a) Nevyhnutné cookies – tieto súbory cookies nezhromažďujú informácie a údaje, na základe ktorých je
                    užívateľ webovej stránky individuálne identifikovateľný, sú ale nevyhnutné pre základnú prevádzku našej
                    webové stránky. Patria sem napríklad cookies, ktoré Vám umožňujú prihlásiť sa do svojho účtu. Bez
                    týchto cookies nie je možné zabezpečovať riadnu prevádzku našej stránky. Ak nechcete, aby sa tieto
                    cookies ukladali, zmeňte si nastavenia v prehliadači.
                </Description>
                <Description>
                    b) Funkčné cookies - tieto súbory cookies umožňujú zapamätať sa preferencie používania ako
                    napríklad nastavenie zvolené pri prehliadaní navštívenej stránky, užívateľské meno, obľúbené dokumenty
                    atď pre zlepšenie užívateľského komfortu.
                </Description>
                <Description>
                    c) Štatistické cookies - tieto súbory cookies nám pomáhajú porozumieť tomu, ako návštevníci
                    interagujú s webovými stránkami anonymným zhromažďovaním a oznamovaním informácií, tým zlepšujeme
                    naše stránky.
                </Description>
                <Description>
                    d) Marketingové cookies - tieto súbory cookies sa používajú za účelom poskytovania a zobrazovania
                    reklamy na základe záujmov užívateľov webových stránok alebo zhromažďovanie osobných údajov od nich na
                    budúce marketingové účely. Na základe týchto súborov je pre nás možné relevantnejšie a efektívnejšie
                    zacieliť priamu marketingovú komunikáciu, ale aj obmedziť počet zobrazovaní reklamy.
                </Description>
                <Description>
                    e) Analytické cookies - tieto súbory cookies slúžia na získanie údajov o návštevnosti webovej stránky,
                    identifikujú pôvod návštevy a tiež zisťujú a zbierajú informácie o tom, ako využíva návštevník túto
                    webovú stránku a slúži na zlepšovanie a zjednodušenie používateľského rozhrania stránky.
                </Description>
            </Container>
            <Container>
                <Label>Za akým účelom cookies využívame?</Label>
                <Description>
                    Súbory cookies umožňujú našej webovej stránke rozpoznávať Vaše zariadenie a zapamätať si určité
                    informácie o Vás a Vašich aktivitách vykonaných počas pripojenia na našu webovú stránku. Cookies
                    používame s cieľom optimálne vytvárať a neustále skvalitňovať naše služby, prispôsobiť ich Vašim
                    záujmom, potrebám a zlepšovať ich štruktúru i obsah.
                </Description>
            </Container>
            <Container>
                <Label>Môžem si zmeniť nastavenia súborov cookies?</Label>
                <Description>
                    Používanie cookies a ich povolenie vo webovom prehliadači je na Vašom rozhodnutí. Treba však
                    pamätať na to, že v prípade zmeny ich nastavenia môže dôjsť k obmedzeniu funkčnosti webovej stránky
                    a na zníženie užívateľského komfortu.
                </Description>
            </Container>
        </Wrapper>
    );
};

export default CookiesConditionsTemplate;
